import ImageLinkWidget from "../../../../components/ImageLinkWidget/component";

/**
 * This function handles creating the proper component structure for a contest promo widget
 * @param {Object} params
 *
 * Key properties of the @param params object
 * @param {string} params.url contest promo url
 * @param {Object} params.logo contest promo logo
 * @param {string} params.logo.aspects.ratioCustom.url url for contest promo logo
 *
 * @returns {JSX} component structure for contest promo widget
 */

const ContestPromoContainer = ({ params }) => {
    if (!params || !params.url || !params.logo?.aspects?.ratioCustom?.url) {
        return null;
    }
    return (
        <ImageLinkWidget
            url={params.url}
            imageURL={params.logo.aspects.ratioCustom.url}
            alt={params?.name}
        />
    );
};

export default ContestPromoContainer;
